const hideEmr = process.env.REACT_APP_HIDE_EMR === 'true';

export const AppNames = {
  emr: {
    name: 'Davis EMR',
    key: 'emr',
    hide: hideEmr,
  },
  hr: {
    name: 'Davis HR',
    key: 'hr',
    hide: false,
  },
};
